import styled from "styled-components";
import { withAlpha } from "../../styles/utils";

export const LessonDetailsContainer = styled.div`
  width: 100%;
  min-width: 0;
  padding: 20px;
  border-bottom: 1px solid ${({ theme }) => withAlpha(theme.colors.inkHex, 0.08)};
  background: ${({ theme }) => withAlpha(theme.colors.brand, 0.02)};
  white-space: normal;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 20px;
  align-items: start;

  @media (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`;

export const ReadBlock = styled.div`
  margin-bottom: 16px;
  &:last-child { margin-bottom: 0; }
`;

export const ReadLabel = styled.div`
  margin-bottom: 4px;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.42)};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.45;
`;

export const ReadText = styled.div`
  color: ${({ theme }) => theme.colors.inkHex};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.55;
  white-space: pre-wrap;
`;

export const EmptyValue = styled.div`
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.3)};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
`;

export const MaterialLink = styled.a`
  color: ${({ theme }) => theme.colors.brand};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.55;
  text-decoration: none;
  word-break: break-all;
  &:hover { text-decoration: underline; }
`;

export const MaterialsColumn = styled.div`min-width: 0;`;

export const SectionTitle = styled.h3`
  margin: 0 0 10px;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.42)};
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 9px 11px;
  border: 1px solid ${({ theme }) => withAlpha(theme.colors.inkHex, 0.14)};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.inkHex};
`;

export const FileIconBox = styled.span`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.05)};
  color: ${({ theme }) => theme.colors.brand};
  svg { width: 15px; height: 19px; }
`;

export const FileMain = styled.span`
  display: block;
  min-width: 0;
  flex: 1 1 auto;
`;

export const FileName = styled.span`
  display: block;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.inkHex};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileMeta = styled.span`
  display: block;
  color: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.42)};
  font-size: 11px;
  font-weight: 400;
  line-height: 1.35;
`;

export const ProgressTrack = styled.span`
  display: block;
  height: 4px;
  margin-top: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: ${({ theme }) => withAlpha(theme.colors.inkHex, 0.08)};
`;

export const ProgressBar = styled.span<{ $progress: number }>`
  display: block;
  width: ${({ $progress }) => `${Math.max(0, Math.min(100, $progress))}%`};
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.colors.brand};
`;

export const VideoPlayersContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  > div {
    width: 100% !important;
    min-height: 0 !important;
    height: auto !important;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    border: 1px solid ${({ theme }) => withAlpha(theme.colors.inkHex, 0.14)};
    border-radius: 12px;
    background: ${({ theme }) => theme.colors.black};
  }
  > div > div { min-height: 0 !important; height: 100% !important; }
  video { min-height: 0 !important; height: 100% !important; }
`;
